import React from 'react';
import { Typography } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';

interface AssetEmptyStateProps {
  message?: string;
}

/**
 * AssetEmptyState - Shared empty state displayed when no assets match the current filter
 */
const AssetEmptyState: React.FC<AssetEmptyStateProps> = ({
  message = 'No assets found.',
}) => {
  return (
    <SectionPaper>
      <Typography variant="body2" sx={{ color: '#64748b', textAlign: 'center', py: 4 }}>
        {message}
      </Typography>
    </SectionPaper>
  );
};

export default AssetEmptyState;
